import { render } from "./HomeiconAndroid.vue?vue&type=template&id=5b78776d&scoped=true"
import script from "./HomeiconAndroid.vue?vue&type=script&lang=js"
export * from "./HomeiconAndroid.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b78776d"]])

export default __exports__